import { InventoryPrimerStatusEnum, PrimerStatusEnum } from '@shared/enums';
import { SampleStatusEnum } from '@shared/enums/sample-status.enum';

export const primerStatusNames: Record<PrimerStatusEnum, string> = {
    [PrimerStatusEnum.ALL]: 'inventory.primer.status.all',
    [PrimerStatusEnum.AVAILABLE]: 'inventory.primer.status.available',
    [PrimerStatusEnum.PENDING]: 'inventory.primer.status.pending',
    [PrimerStatusEnum.OUT_OF_STOCK]: 'inventory.primer.status.outOfStock',
    [PrimerStatusEnum.ARCHIVED]: 'inventory.primer.status.archived',
    [PrimerStatusEnum.TUBE_MISSING]: 'inventory.primer.status.tubeMissing',
    [PrimerStatusEnum.CONTAMINATED]: 'inventory.primer.status.contaminated',
};

export const inventoryPrimerStatusNames: Record<InventoryPrimerStatusEnum, string> = {
    [InventoryPrimerStatusEnum.ALL]: 'inventory.primer.status.all',
    [InventoryPrimerStatusEnum.AVAILABLE]: 'inventory.primer.status.available',
    [InventoryPrimerStatusEnum.PENDING]: 'inventory.primer.status.pending',
    [InventoryPrimerStatusEnum.NOT_RECEIVED]: 'inventory.primer.status.notReceived',
    [InventoryPrimerStatusEnum.CONTAMINATED]: 'inventory.primer.status.contaminated',
    [InventoryPrimerStatusEnum.ARCHIVED]: 'inventory.primer.status.archived',
};

export const sampleStatusNames: Record<SampleStatusEnum, string> = {
    [SampleStatusEnum.ALL]: 'inventory.sample.status.all',
    [SampleStatusEnum.AVAILABLE]: 'inventory.sample.status.available',
    [SampleStatusEnum.EXPIRED]: 'inventory.sample.status.expired',
    [SampleStatusEnum.NOT_RECEIVED]: 'inventory.sample.status.notReceived',
    [SampleStatusEnum.DISPOSED]: 'inventory.sample.status.disposed',
    [SampleStatusEnum.TUBE_MISSING]: 'inventory.sample.status.tubeMissing',
    [SampleStatusEnum.CONTAMINATED]: 'inventory.sample.status.contaminated',
};
